import express, { Router } from 'express';
import webhookRoute from '@/modules/webhook/webhook.route';
import metaWebhookRoute from '@/modules/meta/meta.webhook.route';
import myoperatorWebhookRoute from '@/modules/myoperator/myoperator.webhook.route';

const publicRoutes = express.Router();

interface IRoute {
  path: string;
  route: Router;
}

const defaultIRoute: IRoute[] = [
  {
    path: '/leads',
    route: webhookRoute,
  },
  {
    path: '/meta',
    route: metaWebhookRoute,
  },
  {
    path: '/myoperator',
    route: myoperatorWebhookRoute,
  },
];

defaultIRoute.forEach((route) => {
  publicRoutes.use(route.path, route.route);
});

export default publicRoutes;
